import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import styled from 'styled-components';
import { userInfoSync } from 'hub-http/userInfo';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import EmailSocialAmpPublishingOptionsAndInfo from './EmailSocialAmpPublishingOptionsAndInfo';
import ContentAccessSettingsPublishNotice from 'ui-memberships-settings-lib/components/ContentAccessSettingsPublishNotice';
import { getUnifiedPublishType } from 'ContentEditorUI/redux/selectors/publishSelectors';
import { getPublishDate, getContentModelPublicAccessRules, getContentModelPublicAccessRulesEnabled } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getPortalHasMembershipsAccess, getPortalIsUngatedForMembershipsPublishInfo } from '../redux/selectors/authSelectors';
import { getPostSettingsFullUrl
// @ts-expect-error Untyped module
} from '../redux/selectors/postSettingsSelectors';
import { getSsoEnabledForBlogPostDomain } from '../redux/selectors/postSiteSettingsSelectors';
import { getContentModelTitle } from '../redux/selectors/postContentModelSelectors';
import { PublishTypes } from 'ContentEditorUI/constants/PublishTypes';
import { ContentTypes } from 'ui-memberships-settings-lib/constants/ContentTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Bold = styled.span.withConfig({
  displayName: "BlogPostPublishConfirmModalBodyContent__Bold",
  componentId: "sc-1eayxrt-0"
})(["font-weight:bold;"]);
const BlogPostPublishConfirmModalBodyContent = ({
  isEmailSendingAcknowledgementChecked,
  onEmailSendingAcknowledgementChange,
  onUnregisteredContactsCountFetchSuccess
}) => {
  const contentUrl = useSelector(getPostSettingsFullUrl);
  const publishDate = useSelector(getPublishDate);
  const title = useSelector(getContentModelTitle);
  // @ts-expect-error portalTz() isn't typed
  const scheduledTime = I18n.moment(publishDate).portalTz().format('LLL');
  const portalTimezone = userInfoSync().portal.timezone.id;
  const publishType = useSelector(getUnifiedPublishType);
  const publishKey = publishType === PublishTypes.publish ? 'publishWithoutUrl' : 'publish';
  const portalHasMembershipsAccess = useSelector(getPortalHasMembershipsAccess);
  const portalIsUngatedForMembershipsPublishInfo = useSelector(getPortalIsUngatedForMembershipsPublishInfo);
  const blogPostPublicAccessRules = useSelector(getContentModelPublicAccessRules);
  const blogPostPublicAccessRulesEnabled = useSelector(getContentModelPublicAccessRulesEnabled);
  const ssoEnabledForBlogPostDomain = useSelector(getSsoEnabledForBlogPostDomain);
  const contentAccessProperties = useMemo(() => [{
    publicAccessRules: blogPostPublicAccessRules,
    publicAccessRulesEnabled: blogPostPublicAccessRulesEnabled,
    isSSOEnabled: ssoEnabledForBlogPostDomain
  }], [blogPostPublicAccessRules, blogPostPublicAccessRulesEnabled, ssoEnabledForBlogPostDomain]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "m-bottom-2",
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "publishConfirmModal.contentInfo.name",
        options: {
          title
        }
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "publishConfirmModal.contentInfo.url_jsx",
        options: {
          url: contentUrl
        },
        elements: {
          UILink,
          Bold
        }
      })]
    }), publishType !== PublishTypes.update ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `publishConfirmModal.body.${publishKey}`,
      options: {
        contentUrl,
        scheduledTime,
        portalTimezone
      }
    }) : null, /*#__PURE__*/_jsx(EmailSocialAmpPublishingOptionsAndInfo, {}), portalIsUngatedForMembershipsPublishInfo && portalHasMembershipsAccess && /*#__PURE__*/_jsx(ContentAccessSettingsPublishNotice, {
      contentType: ContentTypes.BLOG_POST,
      contentAccessProperties: contentAccessProperties,
      isEmailSendingAcknowledgementChecked: isEmailSendingAcknowledgementChecked,
      onEmailSendingAcknowledgementChange: onEmailSendingAcknowledgementChange,
      onUnregisteredContactsCountFetchSuccess: onUnregisteredContactsCountFetchSuccess
    })]
  });
};
export default BlogPostPublishConfirmModalBodyContent;